var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-size":"20pt","line-height":"20pt","color":"var(--secondary-color2)","font-family":"Lato-Black"}},[_vm._v(".")])}
var staticRenderFns = []

export { render, staticRenderFns }